import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-invigiericount',
  templateUrl: './invigiericount.component.html',
  styleUrls: ['./invigiericount.component.css']
})
export class InvigiericountComponent implements OnInit {

  loginForm: any;
  totalcount: any = 0;
  pendingcount: any = 0;
  resolvedcount: any = 0;
  rejectedcount: any = 0;
  constructor(private formBuilder: FormBuilder, private api: ApiService, private router: Router) { }

  ngOnInit(): void {

    this.loginForm = this.formBuilder.group({
      email: [window.localStorage.getItem('email')],
    });


    this.api.invigi_eri_total_count(this.loginForm.value).subscribe((data: any) => {
      this.totalcount = data[0]['count']
    });

    this.api.invigi_eri_pending_count(this.loginForm.value).subscribe((data: any) => {
      this.pendingcount = data[0]['count']
    });

    this.api.invigi_eri_resolved_count(this.loginForm.value).subscribe((data: any) => {
      this.resolvedcount = data[0]['count']
    });

    this.api.invigi_eri_rejected_count(this.loginForm.value).subscribe((data: any) => {
      this.rejectedcount = data[0]['count']
    });

  }

}
